module.exports = {
    countryOptions: [
        { value: "AF", label: "Afghanistan" },
        { value: "AX", label: "Aland Islands" },
        { value: "AL", label: "Albania" },
        { value: "DZ", label: "Algeria" },
        { value: "AS", label: "American Samoa" },
        { value: "AD", label: "Andorra" },
        { value: "AO", label: "Angola" },
        { value: "AI", label: "Anguilla" },
        { value: "AQ", label: "Antarctica" },
        { value: "AG", label: "Antigua and Barbuda" },
        { value: "AR", label: "Argentina" },
        { value: "AM", label: "Armenia" },
        { value: "AW", label: "Aruba" },
        { value: "AU", label: "Australia" },
        { value: "AT", label: "Austria" },
        { value: "AZ", label: "Azerbaijan" },
        { value: "BS", label: "Bahamas" },
        { value: "BH", label: "Bahrain" },
        { value: "BD", label: "Bangladesh" },
        { value: "BB", label: "Barbados" },
        { value: "BY", label: "Belarus" },
        { value: "BE", label: "Belgium" },
        { value: "BZ", label: "Belize" },
        { value: "BJ", label: "Benin" },
        { value: "BM", label: "Bermuda" },
        { value: "BT", label: "Bhutan" },
        { value: "BO", label: "Bolivia" },
        { value: "BA", label: "Bosnia and Herzegovina" },
        { value: "BW", label: "Botswana" },
        { value: "BV", label: "Bouvet Island" },
        { value: "BR", label: "Brazil" },
        { value: "VG", label: "British Virgin Islands" },
        { value: "IO", label: "British Indian Ocean Territory" },
        { value: "BN", label: "Brunei Darussalam" },
        { value: "BG", label: "Bulgaria" },
        { value: "BF", label: "Burkina Faso" },
        { value: "BI", label: "Burundi" },
        { value: "KH", label: "Cambodia" },
        { value: "CM", label: "Cameroon" },
        { value: "CA", label: "Canada" },
        { value: "CV", label: "Cape Verde" },
        { value: "KY", label: "Cayman Islands" },
        { value: "CF", label: "Central African Republic" },
        { value: "TD", label: "Chad" },
        { value: "CL", label: "Chile" },
        { value: "CN", label: "China" },
        { value: "HK", label: "Hong Kong Special Administrative Region of China" },
        { value: "MO", label: "Macao Special Administrative Region of China" },
        { value: "CX", label: "Christmas Island" },
        { value: "CC", label: "Cocos (Keeling) Islands" },
        { value: "CO", label: "Colombia" },
        { value: "KM", label: "Comoros" },
        { value: "CG", label: "Congo (Brazzaville)" },
        { value: "CD", label: "Congo Democratic Republic of the" },
        { value: "CK", label: "Cook Islands" },
        { value: "CR", label: "Costa Rica" },
        { value: "CI", label: "Côte d'Ivoire" },
        { value: "HR", label: "Croatia" },
        { value: "CU", label: "Cuba" },
        { value: "CY", label: "Cyprus" },
        { value: "CZ", label: "Czech Republic" },
        { value: "DK", label: "Denmark" },
        { value: "DJ", label: "Djibouti" },
        { value: "DM", label: "Dominica" },
        { value: "DO", label: "Dominican Republic" },
        { value: "EC", label: "Ecuador" },
        { value: "EG", label: "Egypt" },
        { value: "SV", label: "El Salvador" },
        { value: "GQ", label: "Equatorial Guinea" },
        { value: "ER", label: "Eritrea" },
        { value: "EE", label: "Estonia" },
        { value: "ET", label: "Ethiopia" },
        { value: "FK", label: "Falkland Islands (Malvinas)" },
        { value: "FO", label: "Faroe Islands" },
        { value: "FJ", label: "Fiji" },
        { value: "FI", label: "Finland" },
        { value: "FR", label: "France" },
        { value: "GF", label: "French Guiana" },
        { value: "PF", label: "French Polynesia" },
        { value: "TF", label: "French Southern Territories" },
        { value: "GA", label: "Gabon" },
        { value: "GM", label: "Gambia" },
        { value: "GE", label: "Georgia" },
        { value: "DE", label: "Germany" },
        { value: "GH", label: "Ghana" },
        { value: "GI", label: "Gibraltar" },
        { value: "GR", label: "Greece" },
        { value: "GL", label: "Greenland" },
        { value: "GD", label: "Grenada" },
        { value: "GP", label: "Guadeloupe" },
        { value: "GU", label: "Guam" },
        { value: "GT", label: "Guatemala" },
        { value: "GG", label: "Guernsey" },
        { value: "GN", label: "Guinea" },
        { value: "GW", label: "Guinea-Bissau" },
        { value: "GY", label: "Guyana" },
        { value: "HT", label: "Haiti" },
        { value: "HM", label: "Heard Island and Mcdonald Islands" },
        { value: "VA", label: "Holy See (Vatican City State)" },
        { value: "HN", label: "Honduras" },
        { value: "HU", label: "Hungary" },
        { value: "IS", label: "Iceland" },
        { value: "IN", label: "India" },
        { value: "ID", label: "Indonesia" },
        { value: "IR", label: "Iran Islamic Republic of" },
        { value: "IQ", label: "Iraq" },
        { value: "IE", label: "Ireland" },
        { value: "IM", label: "Isle of Man" },
        { value: "IL", label: "Israel" },
        { value: "IT", label: "Italy" },
        { value: "JM", label: "Jamaica" },
        { value: "JP", label: "Japan" },
        { value: "JE", label: "Jersey" },
        { value: "JO", label: "Jordan" },
        { value: "KZ", label: "Kazakhstan" },
        { value: "KE", label: "Kenya" },
        { value: "KI", label: "Kiribati" },
        { value: "KP", label: "Korea Democratic Peoples Republic of" },
        { value: "KR", label: "Korea Republic of" },
        { value: "KW", label: "Kuwait" },
        { value: "KG", label: "Kyrgyzstan" },
        { value: "LA", label: "Lao PDR" },
        { value: "LV", label: "Latvia" },
        { value: "LB", label: "Lebanon" },
        { value: "LS", label: "Lesotho" },
        { value: "LR", label: "Liberia" },
        { value: "LY", label: "Libya" },
        { value: "LI", label: "Liechtenstein" },
        { value: "LT", label: "Lithuania" },
        { value: "LU", label: "Luxembourg" },
        { value: "MK", label: "Macedonia Republic of" },
        { value: "MG", label: "Madagascar" },
        { value: "MW", label: "Malawi" },
        { value: "MY", label: "Malaysia" },
        { value: "MV", label: "Maldives" },
        { value: "ML", label: "Mali" },
        { value: "MT", label: "Malta" },
        { value: "MH", label: "Marshall Islands" },
        { value: "MQ", label: "Martinique" },
        { value: "MR", label: "Mauritania" },
        { value: "MU", label: "Mauritius" },
        { value: "YT", label: "Mayotte" },
        { value: "MX", label: "Mexico" },
        { value: "FM", label: "Micronesia Federated States of" },
        { value: "MD", label: "Moldova" },
        { value: "MC", label: "Monaco" },
        { value: "MN", label: "Mongolia" },
        { value: "ME", label: "Montenegro" },
        { value: "MS", label: "Montserrat" },
        { value: "MA", label: "Morocco" },
        { value: "MZ", label: "Mozambique" },
        { value: "MM", label: "Myanmar" },
        { value: "NA", label: "Namibia" },
        { value: "NR", label: "Nauru" },
        { value: "NP", label: "Nepal" },
        { value: "NL", label: "Netherlands" },
        { value: "AN", label: "Netherlands Antilles" },
        { value: "NC", label: "New Caledonia" },
        { value: "NZ", label: "New Zealand" },
        { value: "NI", label: "Nicaragua" },
        { value: "NE", label: "Niger" },
        { value: "NG", label: "Nigeria" },
        { value: "NU", label: "Niue" },
        { value: "NF", label: "Norfolk Island" },
        { value: "MP", label: "Northern Mariana Islands" },
        { value: "NO", label: "Norway" },
        { value: "OM", label: "Oman" },
        { value: "PK", label: "Pakistan" },
        { value: "PW", label: "Palau" },
        { value: "PS", label: "Palestinian Territory Occupied" },
        { value: "PA", label: "Panama" },
        { value: "PG", label: "Papua New Guinea" },
        { value: "PY", label: "Paraguay" },
        { value: "PE", label: "Peru" },
        { value: "PH", label: "Philippines" },
        { value: "PN", label: "Pitcairn" },
        { value: "PL", label: "Poland" },
        { value: "PT", label: "Portugal" },
        { value: "PR", label: "Puerto Rico" },
        { value: "QA", label: "Qatar" },
        { value: "RE", label: "Réunion" },
        { value: "RO", label: "Romania" },
        { value: "RU", label: "Russian Federation" },
        { value: "RW", label: "Rwanda" },
        { value: "BL", label: "Saint-Barthélemy" },
        { value: "SH", label: "Saint Helena" },
        { value: "KN", label: "Saint Kitts and Nevis" },
        { value: "LC", label: "Saint Lucia" },
        { value: "MF", label: "Saint-Martin (French part)" },
        { value: "PM", label: "Saint Pierre and Miquelon" },
        { value: "VC", label: "Saint Vincent and Grenadines" },
        { value: "WS", label: "Samoa" },
        { value: "SM", label: "San Marino" },
        { value: "ST", label: "Sao Tome and Principe" },
        { value: "SA", label: "Saudi Arabia" },
        { value: "SN", label: "Senegal" },
        { value: "RS", label: "Serbia" },
        { value: "SC", label: "Seychelles" },
        { value: "SL", label: "Sierra Leone" },
        { value: "SG", label: "Singapore" },
        { value: "SK", label: "Slovakia" },
        { value: "SI", label: "Slovenia" },
        { value: "SB", label: "Solomon Islands" },
        { value: "SO", label: "Somalia" },
        { value: "ZA", label: "South Africa" },
        { value: "GS", label: "South Georgia and the South Sandwich Islands" },
        { value: "SS", label: "South Sudan" },
        { value: "ES", label: "Spain" },
        { value: "LK", label: "Sri Lanka" },
        { value: "SD", label: "Sudan" },
        { value: "SR", label: "Suriname" },
        { value: "SJ", label: "Svalbard and Jan Mayen Islands" },
        { value: "SZ", label: "Swaziland" },
        { value: "SE", label: "Sweden" },
        { value: "CH", label: "Switzerland" },
        { value: "SY", label: "Syrian Arab Republic (Syria)" },
        { value: "TW", label: "Taiwan Republic of China" },
        { value: "TJ", label: "Tajikistan" },
        { value: "TZ", label: "Tanzania (United Republic of)" },
        { value: "TH", label: "Thailand" },
        { value: "TL", label: "Timor-Leste" },
        { value: "TG", label: "Togo" },
        { value: "TK", label: "Tokelau" },
        { value: "TO", label: "Tonga" },
        { value: "TT", label: "Trinidad and Tobago" },
        { value: "TN", label: "Tunisia" },
        { value: "TR", label: "Turkey" },
        { value: "TM", label: "Turkmenistan" },
        { value: "TC", label: "Turks and Caicos Islands" },
        { value: "TV", label: "Tuvalu" },
        { value: "UG", label: "Uganda" },
        { value: "UA", label: "Ukraine" },
        { value: "AE", label: "United Arab Emirates" },
        { value: "GB", label: "United Kingdom" },
        { value: "US", label: "United States of America" },
        { value: "UM", label: "United States Minor Outlying Islands" },
        { value: "UY", label: "Uruguay" },
        { value: "UZ", label: "Uzbekistan" },
        { value: "VU", label: "Vanuatu" },
        { value: "VE", label: "Venezuela (Bolivarian Republic of)" },
        { value: "VN", label: "Viet Nam" },
        { value: "VI", label: "Virgin Islands US" },
        { value: "WF", label: "Wallis and Futuna Islands" },
        { value: "EH", label: "Western Sahara" },
        { value: "YE", label: "Yemen" },
        { value: "ZM", label: "Zambia" },
        { value: "ZW", label: "Zimbabwe" },
    ],
    stateOptions: [{
            value: "andaman and nicobar islands",
            label: "Andaman and Nicobar Islands",
        },
        { value: "haryana", label: "Haryana" },
        { value: "tamil nadu", label: "Tamil Nadu" },
        { value: "madhya pradesh", label: "Madhya Pradesh" },
        { value: "jharkhand", label: "Jharkhand" },
        { value: "mizoram", label: "Mizoram" },
        { value: "nagaland", label: "Nagaland" },
        { value: "himachal pradesh", label: "Himachal Pradesh" },
        { value: "tripura", label: "Tripura" },
        { value: "andhra pradesh", label: "Andhra Pradesh" },
        { value: "punjab", label: "Punjab" },
        { value: "chandigarh", label: "Chandigarh" },
        { value: "rajasthan", label: "Rajasthan" },
        { value: "assam", label: "Assam" },
        { value: "odisha", label: "Odisha" },
        { value: "chhattisgarh", label: "Chhattisgarh" },
        { value: "jammu and kashmir", label: "Jammu and Kashmir" },
        { value: "karnataka", label: "Karnataka" },
        { value: "manipur", label: "Manipur" },
        { value: "kerala", label: "Kerala" },
        { value: "delhi", label: "Delhi" },
        { value: "dadra and nagar haveli", label: "Dadra and Nagar Haveli" },
        { value: "puducherry", label: "Puducherry" },
        { value: "uttarakhand", label: "Uttarakhand" },
        { value: "uttar pradesh", label: "Uttar Pradesh" },
        { value: "bihar", label: "Bihar" },
        { value: "gujarat", label: "Gujarat" },
        { value: "telangana", label: "Telangana" },
        { value: "meghalaya", label: "Meghalaya" },
        { value: "himachal praddesh", label: "Himachal Praddesh" },
        { value: "arunachal pradesh", label: "Arunachal Pradesh" },
        { value: "maharashtra", label: "Maharashtra" },
        { value: "goa", label: "Goa" },
        { value: "west bengal", label: "West Bengal" },
    ],
    cityOptions: [{
            label: "Anantapur",
            value: "anantapur",
        },
        {
            label: "Chittoor",
            value: "chittoor",
        },
        {
            label: "East Godavari",
            value: "east godavari",
        },
        {
            label: "Guntur",
            value: "guntur",
        },
        {
            label: "Krishna",
            value: "krishna",
        },
        {
            label: "Kurnool",
            value: "kurnool",
        },
        {
            label: "Nellore",
            value: "nellore",
        },
        {
            label: "Prakasam",
            value: "prakasam",
        },
        {
            label: "Srikakulam",
            value: "srikakulam",
        },
        {
            label: "Visakhapatnam",
            value: "visakhapatnam",
        },
        {
            label: "Vizianagaram",
            value: "vizianagaram",
        },
        {
            label: "West Godavari",
            value: "west godavari",
        },
        {
            label: "YSR Kadapa",
            value: "ysr kadapa",
        },
        {
            label: "Tawang",
            value: "tawang",
        },
        {
            label: "West Kameng",
            value: "west kameng",
        },
        {
            label: "East Kameng",
            value: "east kameng",
        },
        {
            label: "Papum Pare",
            value: "papum pare",
        },
        {
            label: "Kurung Kumey",
            value: "kurung kumey",
        },
        {
            label: "Kra Daadi",
            value: "kra daadi",
        },
        {
            label: "Lower Subansiri",
            value: "lower subansiri",
        },
        {
            label: "Upper Subansiri",
            value: "upper subansiri",
        },
        {
            label: "West Siang",
            value: "west siang",
        },
        {
            label: "East Siang",
            value: "east siang",
        },
        {
            label: "Siang",
            value: "siang",
        },
        {
            label: "Upper Siang",
            value: "upper siang",
        },
        {
            label: "Lower Siang",
            value: "lower siang",
        },
        {
            label: "Lower Dibang Valley",
            value: "lower dibang valley",
        },
        {
            label: "Dibang Valley",
            value: "dibang valley",
        },
        {
            label: "Anjaw",
            value: "anjaw",
        },
        {
            label: "Lohit",
            value: "lohit",
        },
        {
            label: "Namsai",
            value: "namsai",
        },
        {
            label: "Changlang",
            value: "changlang",
        },
        {
            label: "Tirap",
            value: "tirap",
        },
        {
            label: "Longding",
            value: "longding",
        },
        {
            label: "Baksa",
            value: "baksa",
        },
        {
            label: "Barpeta",
            value: "barpeta",
        },
        {
            label: "Biswanath",
            value: "biswanath",
        },
        {
            label: "Bongaigaon",
            value: "bongaigaon",
        },
        {
            label: "Cachar",
            value: "cachar",
        },
        {
            label: "Charaideo",
            value: "charaideo",
        },
        {
            label: "Chirang",
            value: "chirang",
        },
        {
            label: "Darrang",
            value: "darrang",
        },
        {
            label: "Dhemaji",
            value: "dhemaji",
        },
        {
            label: "Dhubri",
            value: "dhubri",
        },
        {
            label: "Dibrugarh",
            value: "dibrugarh",
        },
        {
            label: "Goalpara",
            value: "goalpara",
        },
        {
            label: "Golaghat",
            value: "golaghat",
        },
        {
            label: "Hailakandi",
            value: "hailakandi",
        },
        {
            label: "Hojai",
            value: "hojai",
        },
        {
            label: "Jorhat",
            value: "jorhat",
        },
        {
            label: "Kamrup Metropolitan",
            value: "kamrup metropolitan",
        },
        {
            label: "Kamrup",
            value: "kamrup",
        },
        {
            label: "Karbi Anglong",
            value: "karbi anglong",
        },
        {
            label: "Karimganj",
            value: "karimganj",
        },
        {
            label: "Kokrajhar",
            value: "kokrajhar",
        },
        {
            label: "Lakhimpur",
            value: "lakhimpur",
        },
        {
            label: "Majuli",
            value: "majuli",
        },
        {
            label: "Morigaon",
            value: "morigaon",
        },
        {
            label: "Nagaon",
            value: "nagaon",
        },
        {
            label: "Nalbari",
            value: "nalbari",
        },
        {
            label: "Dima Hasao",
            value: "dima hasao",
        },
        {
            label: "Sivasagar",
            value: "sivasagar",
        },
        {
            label: "Sonitpur",
            value: "sonitpur",
        },
        {
            label: "South Salmara-Mankachar",
            value: "south salmara-mankachar",
        },
        {
            label: "Tinsukia",
            value: "tinsukia",
        },
        {
            label: "Udalguri",
            value: "udalguri",
        },
        {
            label: "West Karbi Anglong",
            value: "west karbi anglong",
        },
        {
            label: "Araria",
            value: "araria",
        },
        {
            label: "Arwal",
            value: "arwal",
        },
        {
            label: "Aurangabad",
            value: "aurangabad",
        },
        {
            label: "Banka",
            value: "banka",
        },
        {
            label: "Begusarai",
            value: "begusarai",
        },
        {
            label: "Bhagalpur",
            value: "bhagalpur",
        },
        {
            label: "Bhojpur",
            value: "bhojpur",
        },
        {
            label: "Buxar",
            value: "buxar",
        },
        {
            label: "Darbhanga",
            value: "darbhanga",
        },
        {
            label: "East Champaran (Motihari)",
            value: "east champaran (motihari)",
        },
        {
            label: "Gaya",
            value: "gaya",
        },
        {
            label: "Gopalganj",
            value: "gopalganj",
        },
        {
            label: "Jamui",
            value: "jamui",
        },
        {
            label: "Jehanabad",
            value: "jehanabad",
        },
        {
            label: "Kaimur (Bhabua)",
            value: "kaimur (bhabua)",
        },
        {
            label: "Katihar",
            value: "katihar",
        },
        {
            label: "Khagaria",
            value: "khagaria",
        },
        {
            label: "Kishanganj",
            value: "kishanganj",
        },
        {
            label: "Lakhisarai",
            value: "lakhisarai",
        },
        {
            label: "Madhepura",
            value: "madhepura",
        },
        {
            label: "Madhubani",
            value: "madhubani",
        },
        {
            label: "Munger (Monghyr)",
            value: "munger (monghyr)",
        },
        {
            label: "Muzaffarpur",
            value: "muzaffarpur",
        },
        {
            label: "Nalanda",
            value: "nalanda",
        },
        {
            label: "Nawada",
            value: "nawada",
        },
        {
            label: "Patna",
            value: "patna",
        },
        {
            label: "Purnia (Purnea)",
            value: "purnia (purnea)",
        },
        {
            label: "Rohtas",
            value: "rohtas",
        },
        {
            label: "Saharsa",
            value: "saharsa",
        },
        {
            label: "Samastipur",
            value: "samastipur",
        },
        {
            label: "Saran",
            value: "saran",
        },
        {
            label: "Sheikhpura",
            value: "sheikhpura",
        },
        {
            label: "Sheohar",
            value: "sheohar",
        },
        {
            label: "Sitamarhi",
            value: "sitamarhi",
        },
        {
            label: "Siwan",
            value: "siwan",
        },
        {
            label: "Supaul",
            value: "supaul",
        },
        {
            label: "Vaishali",
            value: "vaishali",
        },
        {
            label: "West Champaran",
            value: "west champaran",
        },
        {
            label: "Chandigarh",
            value: "chandigarh",
        },
        {
            label: "Balod",
            value: "balod",
        },
        {
            label: "Baloda Bazar",
            value: "baloda bazar",
        },
        {
            label: "Balrampur",
            value: "balrampur",
        },
        {
            label: "Bastar",
            value: "bastar",
        },
        {
            label: "Bemetara",
            value: "bemetara",
        },
        {
            label: "Bijapur",
            value: "bijapur",
        },
        {
            label: "Bilaspur",
            value: "bilaspur",
        },
        {
            label: "Dantewada (South Bastar)",
            value: "dantewada (south bastar)",
        },
        {
            label: "Dhamtari",
            value: "dhamtari",
        },
        {
            label: "Durg",
            value: "durg",
        },
        {
            label: "Gariyaband",
            value: "gariyaband",
        },
        {
            label: "Janjgir-Champa",
            value: "janjgir-champa",
        },
        {
            label: "Jashpur",
            value: "jashpur",
        },
        {
            label: "Kabirdham (Kawardha)",
            value: "kabirdham (kawardha)",
        },
        {
            label: "Kanker (North Bastar)",
            value: "kanker (north bastar)",
        },
        {
            label: "Kondagaon",
            value: "kondagaon",
        },
        {
            label: "Korba",
            value: "korba",
        },
        {
            label: "Korea (Koriya)",
            value: "korea (koriya)",
        },
        {
            label: "Mahasamund",
            value: "mahasamund",
        },
        {
            label: "Mungeli",
            value: "mungeli",
        },
        {
            label: "Narayanpur",
            value: "narayanpur",
        },
        {
            label: "Raigarh",
            value: "raigarh",
        },
        {
            label: "Raipur",
            value: "raipur",
        },
        {
            label: "Rajnandgaon",
            value: "rajnandgaon",
        },
        {
            label: "Sukma",
            value: "sukma",
        },
        {
            label: "Surajpur  ",
            value: "surajpur  ",
        },
        {
            label: "Surguja",
            value: "surguja",
        },
        {
            label: "Dadra & Nagar Haveli",
            value: "dadra & nagar haveli",
        },
        {
            label: "Daman",
            value: "daman",
        },
        {
            label: "Diu",
            value: "diu",
        },
        {
            label: "Central Delhi",
            value: "central delhi",
        },
        {
            label: "East Delhi",
            value: "east delhi",
        },
        {
            label: "New Delhi",
            value: "new delhi",
        },
        {
            label: "North Delhi",
            value: "north delhi",
        },
        {
            label: "North East  Delhi",
            value: "north east  delhi",
        },
        {
            label: "North West  Delhi",
            value: "north west  delhi",
        },
        {
            label: "Shahdara",
            value: "shahdara",
        },
        {
            label: "South Delhi",
            value: "south delhi",
        },
        {
            label: "South East Delhi",
            value: "south east delhi",
        },
        {
            label: "South West  Delhi",
            value: "south west  delhi",
        },
        {
            label: "West Delhi",
            value: "west delhi",
        },
        {
            label: "North Goa",
            value: "north goa",
        },
        {
            label: "South Goa",
            value: "south goa",
        },
        {
            label: "Ahmedabad",
            value: "ahmedabad",
        },
        {
            label: "Amreli",
            value: "amreli",
        },
        {
            label: "Anand",
            value: "anand",
        },
        {
            label: "Aravalli",
            value: "aravalli",
        },
        {
            label: "Banaskantha (Palanpur)",
            value: "banaskantha (palanpur)",
        },
        {
            label: "Bharuch",
            value: "bharuch",
        },
        {
            label: "Bhavnagar",
            value: "bhavnagar",
        },
        {
            label: "Botad",
            value: "botad",
        },
        {
            label: "Chhota Udepur",
            value: "chhota udepur",
        },
        {
            label: "Dahod",
            value: "dahod",
        },
        {
            label: "Dangs (Ahwa)",
            value: "dangs (ahwa)",
        },
        {
            label: "Devbhoomi Dwarka",
            value: "devbhoomi dwarka",
        },
        {
            label: "Gandhinagar",
            value: "gandhinagar",
        },
        {
            label: "Gir Somnath",
            value: "gir somnath",
        },
        {
            label: "Jamnagar",
            value: "jamnagar",
        },
        {
            label: "Junagadh",
            value: "junagadh",
        },
        {
            label: "Kachchh",
            value: "kachchh",
        },
        {
            label: "Kheda (Nadiad)",
            value: "kheda (nadiad)",
        },
        {
            label: "Mahisagar",
            value: "mahisagar",
        },
        {
            label: "Mehsana",
            value: "mehsana",
        },
        {
            label: "Morbi",
            value: "morbi",
        },
        {
            label: "Narmada (Rajpipla)",
            value: "narmada (rajpipla)",
        },
        {
            label: "Navsari",
            value: "navsari",
        },
        {
            label: "Panchmahal (Godhra)",
            value: "panchmahal (godhra)",
        },
        {
            label: "Patan",
            value: "patan",
        },
        {
            label: "Porbandar",
            value: "porbandar",
        },
        {
            label: "Rajkot",
            value: "rajkot",
        },
        {
            label: "Sabarkantha (Himmatnagar)",
            value: "sabarkantha (himmatnagar)",
        },
        {
            label: "Surat",
            value: "surat",
        },
        {
            label: "Surendranagar",
            value: "surendranagar",
        },
        {
            label: "Tapi (Vyara)",
            value: "tapi (vyara)",
        },
        {
            label: "Vadodara",
            value: "vadodara",
        },
        {
            label: "Valsad",
            value: "valsad",
        },
        {
            label: "Ambala",
            value: "ambala",
        },
        {
            label: "Bhiwani",
            value: "bhiwani",
        },
        {
            label: "Charkhi Dadri",
            value: "charkhi dadri",
        },
        {
            label: "Faridabad",
            value: "faridabad",
        },
        {
            label: "Fatehabad",
            value: "fatehabad",
        },
        {
            label: "Gurgaon",
            value: "gurgaon",
        },
        {
            label: "Hisar",
            value: "hisar",
        },
        {
            label: "Jhajjar",
            value: "jhajjar",
        },
        {
            label: "Jind",
            value: "jind",
        },
        {
            label: "Kaithal",
            value: "kaithal",
        },
        {
            label: "Karnal",
            value: "karnal",
        },
        {
            label: "Kurukshetra",
            value: "kurukshetra",
        },
        {
            label: "Mahendragarh",
            value: "mahendragarh",
        },
        {
            label: "Mewat",
            value: "mewat",
        },
        {
            label: "Palwal",
            value: "palwal",
        },
        {
            label: "Panchkula",
            value: "panchkula",
        },
        {
            label: "Panipat",
            value: "panipat",
        },
        {
            label: "Rewari",
            value: "rewari",
        },
        {
            label: "Rohtak",
            value: "rohtak",
        },
        {
            label: "Sirsa",
            value: "sirsa",
        },
        {
            label: "Sonipat",
            value: "sonipat",
        },
        {
            label: "Yamunanagar",
            value: "yamunanagar",
        },
        {
            label: "Bilaspur",
            value: "bilaspur",
        },
        {
            label: "Chamba",
            value: "chamba",
        },
        {
            label: "Hamirpur",
            value: "hamirpur",
        },
        {
            label: "Kangra",
            value: "kangra",
        },
        {
            label: "Kinnaur",
            value: "kinnaur",
        },
        {
            label: "Kullu",
            value: "kullu",
        },
        {
            label: "Lahaul &amp; Spiti",
            value: "lahaul &amp; spiti",
        },
        {
            label: "Mandi",
            value: "mandi",
        },
        {
            label: "Shimla",
            value: "shimla",
        },
        {
            label: "Sirmaur (Sirmour)",
            value: "sirmaur (sirmour)",
        },
        {
            label: "Solan",
            value: "solan",
        },
        {
            label: "Una",
            value: "una",
        },
        {
            label: "Anantnag",
            value: "anantnag",
        },
        {
            label: "Bandipore",
            value: "bandipore",
        },
        {
            label: "Baramulla",
            value: "baramulla",
        },
        {
            label: "Budgam",
            value: "budgam",
        },
        {
            label: "Doda",
            value: "doda",
        },
        {
            label: "Ganderbal",
            value: "ganderbal",
        },
        {
            label: "Jammu",
            value: "jammu",
        },
        {
            label: "Kargil",
            value: "kargil",
        },
        {
            label: "Kathua",
            value: "kathua",
        },
        {
            label: "Kishtwar",
            value: "kishtwar",
        },
        {
            label: "Kulgam",
            value: "kulgam",
        },
        {
            label: "Kupwara",
            value: "kupwara",
        },
        {
            label: "Leh",
            value: "leh",
        },
        {
            label: "Poonch",
            value: "poonch",
        },
        {
            label: "Pulwama",
            value: "pulwama",
        },
        {
            label: "Rajouri",
            value: "rajouri",
        },
        {
            label: "Ramban",
            value: "ramban",
        },
        {
            label: "Reasi",
            value: "reasi",
        },
        {
            label: "Samba",
            value: "samba",
        },
        {
            label: "Shopian",
            value: "shopian",
        },
        {
            label: "Srinagar",
            value: "srinagar",
        },
        {
            label: "Udhampur",
            value: "udhampur",
        },
        {
            label: "Bokaro",
            value: "bokaro",
        },
        {
            label: "Chatra",
            value: "chatra",
        },
        {
            label: "Deoghar",
            value: "deoghar",
        },
        {
            label: "Dhanbad",
            value: "dhanbad",
        },
        {
            label: "Dumka",
            value: "dumka",
        },
        {
            label: "East Singhbhum",
            value: "east singhbhum",
        },
        {
            label: "Garhwa",
            value: "garhwa",
        },
        {
            label: "Giridih",
            value: "giridih",
        },
        {
            label: "Godda",
            value: "godda",
        },
        {
            label: "Gumla",
            value: "gumla",
        },
        {
            label: "Hazaribag",
            value: "hazaribag",
        },
        {
            label: "Jamtara",
            value: "jamtara",
        },
        {
            label: "Khunti",
            value: "khunti",
        },
        {
            label: "Koderma",
            value: "koderma",
        },
        {
            label: "Latehar",
            value: "latehar",
        },
        {
            label: "Lohardaga",
            value: "lohardaga",
        },
        {
            label: "Pakur",
            value: "pakur",
        },
        {
            label: "Palamu",
            value: "palamu",
        },
        {
            label: "Ramgarh",
            value: "ramgarh",
        },
        {
            label: "Ranchi",
            value: "ranchi",
        },
        {
            label: "Sahibganj",
            value: "sahibganj",
        },
        {
            label: "Seraikela-Kharsawan",
            value: "seraikela-kharsawan",
        },
        {
            label: "Simdega",
            value: "simdega",
        },
        {
            label: "West Singhbhum",
            value: "west singhbhum",
        },
        {
            label: "Bagalkot",
            value: "bagalkot",
        },
        {
            label: "Ballari (Bellary)",
            value: "ballari (bellary)",
        },
        {
            label: "Belagavi (Belgaum)",
            value: "belagavi (belgaum)",
        },
        {
            label: "Bengaluru (Bangalore) Rural",
            value: "bengaluru (bangalore) rural",
        },
        {
            label: "Bengaluru (Bangalore) Urban",
            value: "bengaluru (bangalore) urban",
        },
        {
            label: "Bidar",
            value: "bidar",
        },
        {
            label: "Chamarajanagar",
            value: "chamarajanagar",
        },
        {
            label: "Chikballapur",
            value: "chikballapur",
        },
        {
            label: "Chikkamagaluru (Chikmagalur)",
            value: "chikkamagaluru (chikmagalur)",
        },
        {
            label: "Chitradurga",
            value: "chitradurga",
        },
        {
            label: "Dakshina Kannada",
            value: "dakshina kannada",
        },
        {
            label: "Davangere",
            value: "davangere",
        },
        {
            label: "Dharwad",
            value: "dharwad",
        },
        {
            label: "Gadag",
            value: "gadag",
        },
        {
            label: "Hassan",
            value: "hassan",
        },
        {
            label: "Haveri",
            value: "haveri",
        },
        {
            label: "Kalaburagi (Gulbarga)",
            value: "kalaburagi (gulbarga)",
        },
        {
            label: "Kodagu",
            value: "kodagu",
        },
        {
            label: "Kolar",
            value: "kolar",
        },
        {
            label: "Koppal",
            value: "koppal",
        },
        {
            label: "Mandya",
            value: "mandya",
        },
        {
            label: "Mysuru (Mysore)",
            value: "mysuru (mysore)",
        },
        {
            label: "Raichur",
            value: "raichur",
        },
        {
            label: "Ramanagara",
            value: "ramanagara",
        },
        {
            label: "Shivamogga (Shimoga)",
            value: "shivamogga (shimoga)",
        },
        {
            label: "Tumakuru (Tumkur)",
            value: "tumakuru (tumkur)",
        },
        {
            label: "Udupi",
            value: "udupi",
        },
        {
            label: "Uttara Kannada (Karwar)",
            value: "uttara kannada (karwar)",
        },
        {
            label: "Vijayapura (Bijapur)",
            value: "vijayapura (bijapur)",
        },
        {
            label: "Yadgir",
            value: "yadgir",
        },
        {
            label: "Alappuzha",
            value: "alappuzha",
        },
        {
            label: "Ernakulam",
            value: "ernakulam",
        },
        {
            label: "Idukki",
            value: "idukki",
        },
        {
            label: "Kannur",
            value: "kannur",
        },
        {
            label: "Kasaragod",
            value: "kasaragod",
        },
        {
            label: "Kollam",
            value: "kollam",
        },
        {
            label: "Kottayam",
            value: "kottayam",
        },
        {
            label: "Kozhikode",
            value: "kozhikode",
        },
        {
            label: "Malappuram",
            value: "malappuram",
        },
        {
            label: "Palakkad",
            value: "palakkad",
        },
        {
            label: "Pathanamthitta",
            value: "pathanamthitta",
        },
        {
            label: "Thiruvananthapuram",
            value: "thiruvananthapuram",
        },
        {
            label: "Thrissur",
            value: "thrissur",
        },
        {
            label: "Wayanad",
            value: "wayanad",
        },
        {
            label: "Agatti",
            value: "agatti",
        },
        {
            label: "Amini",
            value: "amini",
        },
        {
            label: "Androth",
            value: "androth",
        },
        {
            label: "Bithra",
            value: "bithra",
        },
        {
            label: "Chethlath",
            value: "chethlath",
        },
        {
            label: "Kavaratti",
            value: "kavaratti",
        },
        {
            label: "Kadmath",
            value: "kadmath",
        },
        {
            label: "Kalpeni",
            value: "kalpeni",
        },
        {
            label: "Kilthan",
            value: "kilthan",
        },
        {
            label: "Minicoy",
            value: "minicoy",
        },
        {
            label: "Agar Malwa",
            value: "agar malwa",
        },
        {
            label: "Alirajpur",
            value: "alirajpur",
        },
        {
            label: "Anuppur",
            value: "anuppur",
        },
        {
            label: "Ashoknagar",
            value: "ashoknagar",
        },
        {
            label: "Balaghat",
            value: "balaghat",
        },
        {
            label: "Barwani",
            value: "barwani",
        },
        {
            label: "Betul",
            value: "betul",
        },
        {
            label: "Bhind",
            value: "bhind",
        },
        {
            label: "Bhopal",
            value: "bhopal",
        },
        {
            label: "Burhanpur",
            value: "burhanpur",
        },
        {
            label: "Chhatarpur",
            value: "chhatarpur",
        },
        {
            label: "Chhindwara",
            value: "chhindwara",
        },
        {
            label: "Damoh",
            value: "damoh",
        },
        {
            label: "Datia",
            value: "datia",
        },
        {
            label: "Dewas",
            value: "dewas",
        },
        {
            label: "Dhar",
            value: "dhar",
        },
        {
            label: "Dindori",
            value: "dindori",
        },
        {
            label: "Guna",
            value: "guna",
        },
        {
            label: "Gwalior",
            value: "gwalior",
        },
        {
            label: "Harda",
            value: "harda",
        },
        {
            label: "Hoshangabad",
            value: "hoshangabad",
        },
        {
            label: "Indore",
            value: "indore",
        },
        {
            label: "Jabalpur",
            value: "jabalpur",
        },
        {
            label: "Jhabua",
            value: "jhabua",
        },
        {
            label: "Katni",
            value: "katni",
        },
        {
            label: "Khandwa",
            value: "khandwa",
        },
        {
            label: "Khargone",
            value: "khargone",
        },
        {
            label: "Mandla",
            value: "mandla",
        },
        {
            label: "Mandsaur",
            value: "mandsaur",
        },
        {
            label: "Morena",
            value: "morena",
        },
        {
            label: "Narsinghpur",
            value: "narsinghpur",
        },
        {
            label: "Neemuch",
            value: "neemuch",
        },
        {
            label: "Panna",
            value: "panna",
        },
        {
            label: "Raisen",
            value: "raisen",
        },
        {
            label: "Rajgarh",
            value: "rajgarh",
        },
        {
            label: "Ratlam",
            value: "ratlam",
        },
        {
            label: "Rewa",
            value: "rewa",
        },
        {
            label: "Sagar",
            value: "sagar",
        },
        {
            label: "Satna",
            value: "satna",
        },
        {
            label: "Sehore",
            value: "sehore",
        },
        {
            label: "Seoni",
            value: "seoni",
        },
        {
            label: "Shahdol",
            value: "shahdol",
        },
        {
            label: "Shajapur",
            value: "shajapur",
        },
        {
            label: "Sheopur",
            value: "sheopur",
        },
        {
            label: "Shivpuri",
            value: "shivpuri",
        },
        {
            label: "Sidhi",
            value: "sidhi",
        },
        {
            label: "Singrauli",
            value: "singrauli",
        },
        {
            label: "Tikamgarh",
            value: "tikamgarh",
        },
        {
            label: "Ujjain",
            value: "ujjain",
        },
        {
            label: "Umaria",
            value: "umaria",
        },
        {
            label: "Vidisha",
            value: "vidisha",
        },
        {
            label: "Ahmednagar",
            value: "ahmednagar",
        },
        {
            label: "Akola",
            value: "akola",
        },
        {
            label: "Amravati",
            value: "amravati",
        },
        {
            label: "Aurangabad",
            value: "aurangabad",
        },
        {
            label: "Beed",
            value: "beed",
        },
        {
            label: "Bhandara",
            value: "bhandara",
        },
        {
            label: "Buldhana",
            value: "buldhana",
        },
        {
            label: "Chandrapur",
            value: "chandrapur",
        },
        {
            label: "Dhule",
            value: "dhule",
        },
        {
            label: "Gadchiroli",
            value: "gadchiroli",
        },
        {
            label: "Gondia",
            value: "gondia",
        },
        {
            label: "Hingoli",
            value: "hingoli",
        },
        {
            label: "Jalgaon",
            value: "jalgaon",
        },
        {
            label: "Jalna",
            value: "jalna",
        },
        {
            label: "Kolhapur",
            value: "kolhapur",
        },
        {
            label: "Latur",
            value: "latur",
        },
        {
            label: "Mumbai City",
            value: "mumbai city",
        },
        {
            label: "Mumbai Suburban",
            value: "mumbai suburban",
        },
        {
            label: "Nagpur",
            value: "nagpur",
        },
        {
            label: "Nanded",
            value: "nanded",
        },
        {
            label: "Nandurbar",
            value: "nandurbar",
        },
        {
            label: "Nashik",
            value: "nashik",
        },
        {
            label: "Osmanabad",
            value: "osmanabad",
        },
        {
            label: "Palghar",
            value: "palghar",
        },
        {
            label: "Parbhani",
            value: "parbhani",
        },
        {
            label: "Pune",
            value: "pune",
        },
        {
            label: "Raigad",
            value: "raigad",
        },
        {
            label: "Ratnagiri",
            value: "ratnagiri",
        },
        {
            label: "Sangli",
            value: "sangli",
        },
        {
            label: "Satara",
            value: "satara",
        },
        {
            label: "Sindhudurg",
            value: "sindhudurg",
        },
        {
            label: "Solapur",
            value: "solapur",
        },
        {
            label: "Thane",
            value: "thane",
        },
        {
            label: "Wardha",
            value: "wardha",
        },
        {
            label: "Washim",
            value: "washim",
        },
        {
            label: "Yavatmal",
            value: "yavatmal",
        },
        {
            label: "Bishnupur",
            value: "bishnupur",
        },
        {
            label: "Chandel",
            value: "chandel",
        },
        {
            label: "Churachandpur",
            value: "churachandpur",
        },
        {
            label: "Imphal East",
            value: "imphal east",
        },
        {
            label: "Imphal West",
            value: "imphal west",
        },
        {
            label: "Jiribam",
            value: "jiribam",
        },
        {
            label: "Kakching",
            value: "kakching",
        },
        {
            label: "Kamjong",
            value: "kamjong",
        },
        {
            label: "Kangpokpi",
            value: "kangpokpi",
        },
        {
            label: "Noney",
            value: "noney",
        },
        {
            label: "Pherzawl",
            value: "pherzawl",
        },
        {
            label: "Senapati",
            value: "senapati",
        },
        {
            label: "Tamenglong",
            value: "tamenglong",
        },
        {
            label: "Tengnoupal",
            value: "tengnoupal",
        },
        {
            label: "Thoubal",
            value: "thoubal",
        },
        {
            label: "Ukhrul",
            value: "ukhrul",
        },
        {
            label: "East Garo Hills",
            value: "east garo hills",
        },
        {
            label: "East Jaintia Hills",
            value: "east jaintia hills",
        },
        {
            label: "East Khasi Hills",
            value: "east khasi hills",
        },
        {
            label: "North Garo Hills",
            value: "north garo hills",
        },
        {
            label: "Ri Bhoi",
            value: "ri bhoi",
        },
        {
            label: "South Garo Hills",
            value: "south garo hills",
        },
        {
            label: "South West Garo Hills ",
            value: "south west garo hills ",
        },
        {
            label: "South West Khasi Hills",
            value: "south west khasi hills",
        },
        {
            label: "West Garo Hills",
            value: "west garo hills",
        },
        {
            label: "West Jaintia Hills",
            value: "west jaintia hills",
        },
        {
            label: "West Khasi Hills",
            value: "west khasi hills",
        },
        {
            label: "Aizawl",
            value: "aizawl",
        },
        {
            label: "Champhai",
            value: "champhai",
        },
        {
            label: "Kolasib",
            value: "kolasib",
        },
        {
            label: "Lawngtlai",
            value: "lawngtlai",
        },
        {
            label: "Lunglei",
            value: "lunglei",
        },
        {
            label: "Mamit",
            value: "mamit",
        },
        {
            label: "Saiha",
            value: "saiha",
        },
        {
            label: "Serchhip",
            value: "serchhip",
        },
        {
            label: "Dimapur",
            value: "dimapur",
        },
        {
            label: "Kiphire",
            value: "kiphire",
        },
        {
            label: "Kohima",
            value: "kohima",
        },
        {
            label: "Longleng",
            value: "longleng",
        },
        {
            label: "Mokokchung",
            value: "mokokchung",
        },
        {
            label: "Mon",
            value: "mon",
        },
        {
            label: "Peren",
            value: "peren",
        },
        {
            label: "Phek",
            value: "phek",
        },
        {
            label: "Tuensang",
            value: "tuensang",
        },
        {
            label: "Wokha",
            value: "wokha",
        },
        {
            label: "Zunheboto",
            value: "zunheboto",
        },
        {
            label: "Angul",
            value: "angul",
        },
        {
            label: "Balangir",
            value: "balangir",
        },
        {
            label: "Balasore",
            value: "balasore",
        },
        {
            label: "Bargarh",
            value: "bargarh",
        },
        {
            label: "Bhadrak",
            value: "bhadrak",
        },
        {
            label: "Boudh",
            value: "boudh",
        },
        {
            label: "Cuttack",
            value: "cuttack",
        },
        {
            label: "Deogarh",
            value: "deogarh",
        },
        {
            label: "Dhenkanal",
            value: "dhenkanal",
        },
        {
            label: "Gajapati",
            value: "gajapati",
        },
        {
            label: "Ganjam",
            value: "ganjam",
        },
        {
            label: "Jagatsinghapur",
            value: "jagatsinghapur",
        },
        {
            label: "Jajpur",
            value: "jajpur",
        },
        {
            label: "Jharsuguda",
            value: "jharsuguda",
        },
        {
            label: "Kalahandi",
            value: "kalahandi",
        },
        {
            label: "Kandhamal",
            value: "kandhamal",
        },
        {
            label: "Kendrapara",
            value: "kendrapara",
        },
        {
            label: "Kendujhar (Keonjhar)",
            value: "kendujhar (keonjhar)",
        },
        {
            label: "Khordha",
            value: "khordha",
        },
        {
            label: "Koraput",
            value: "koraput",
        },
        {
            label: "Malkangiri",
            value: "malkangiri",
        },
        {
            label: "Mayurbhanj",
            value: "mayurbhanj",
        },
        {
            label: "Nabarangpur",
            value: "nabarangpur",
        },
        {
            label: "Nayagarh",
            value: "nayagarh",
        },
        {
            label: "Nuapada",
            value: "nuapada",
        },
        {
            label: "Puri",
            value: "puri",
        },
        {
            label: "Rayagada",
            value: "rayagada",
        },
        {
            label: "Sambalpur",
            value: "sambalpur",
        },
        {
            label: "Sonepur",
            value: "sonepur",
        },
        {
            label: "Sundargarh",
            value: "sundargarh",
        },
        {
            label: "Karaikal",
            value: "karaikal",
        },
        {
            label: "Mahe",
            value: "mahe",
        },
        {
            label: "Pondicherry",
            value: "pondicherry",
        },
        {
            label: "Yanam",
            value: "yanam",
        },
        {
            label: "Amritsar",
            value: "amritsar",
        },
        {
            label: "Barnala",
            value: "barnala",
        },
        {
            label: "Bathinda",
            value: "bathinda",
        },
        {
            label: "Faridkot",
            value: "faridkot",
        },
        {
            label: "Fatehgarh Sahib",
            value: "fatehgarh sahib",
        },
        {
            label: "Fazilka",
            value: "fazilka",
        },
        {
            label: "Ferozepur",
            value: "ferozepur",
        },
        {
            label: "Gurdaspur",
            value: "gurdaspur",
        },
        {
            label: "Hoshiarpur",
            value: "hoshiarpur",
        },
        {
            label: "Jalandhar",
            value: "jalandhar",
        },
        {
            label: "Kapurthala",
            value: "kapurthala",
        },
        {
            label: "Ludhiana",
            value: "ludhiana",
        },
        {
            label: "Mansa",
            value: "mansa",
        },
        {
            label: "Moga",
            value: "moga",
        },
        {
            label: "Muktsar",
            value: "muktsar",
        },
        {
            label: "Nawanshahr (Shahid Bhagat Singh Nagar)",
            value: "nawanshahr (shahid bhagat singh nagar)",
        },
        {
            label: "Pathankot",
            value: "pathankot",
        },
        {
            label: "Patiala",
            value: "patiala",
        },
        {
            label: "Rupnagar",
            value: "rupnagar",
        },
        {
            label: "Sahibzada Ajit Singh Nagar (Mohali)",
            value: "sahibzada ajit singh nagar (mohali)",
        },
        {
            label: "Sangrur",
            value: "sangrur",
        },
        {
            label: "Tarn Taran",
            value: "tarn taran",
        },
        {
            label: "Ajmer",
            value: "ajmer",
        },
        {
            label: "Alwar",
            value: "alwar",
        },
        {
            label: "Banswara",
            value: "banswara",
        },
        {
            label: "Baran",
            value: "baran",
        },
        {
            label: "Barmer",
            value: "barmer",
        },
        {
            label: "Bharatpur",
            value: "bharatpur",
        },
        {
            label: "Bhilwara",
            value: "bhilwara",
        },
        {
            label: "Bikaner",
            value: "bikaner",
        },
        {
            label: "Bundi",
            value: "bundi",
        },
        {
            label: "Chittorgarh",
            value: "chittorgarh",
        },
        {
            label: "Churu",
            value: "churu",
        },
        {
            label: "Dausa",
            value: "dausa",
        },
        {
            label: "Dholpur",
            value: "dholpur",
        },
        {
            label: "Dungarpur",
            value: "dungarpur",
        },
        {
            label: "Hanumangarh",
            value: "hanumangarh",
        },
        {
            label: "Jaipur",
            value: "jaipur",
        },
        {
            label: "Jaisalmer",
            value: "jaisalmer",
        },
        {
            label: "Jalore",
            value: "jalore",
        },
        {
            label: "Jhalawar",
            value: "jhalawar",
        },
        {
            label: "Jhunjhunu",
            value: "jhunjhunu",
        },
        {
            label: "Jodhpur",
            value: "jodhpur",
        },
        {
            label: "Karauli",
            value: "karauli",
        },
        {
            label: "Kota",
            value: "kota",
        },
        {
            label: "Nagaur",
            value: "nagaur",
        },
        {
            label: "Pali",
            value: "pali",
        },
        {
            label: "Pratapgarh",
            value: "pratapgarh",
        },
        {
            label: "Rajsamand",
            value: "rajsamand",
        },
        {
            label: "Sawai Madhopur",
            value: "sawai madhopur",
        },
        {
            label: "Sikar",
            value: "sikar",
        },
        {
            label: "Sirohi",
            value: "sirohi",
        },
        {
            label: "Sri Ganganagar",
            value: "sri ganganagar",
        },
        {
            label: "Tonk",
            value: "tonk",
        },
        {
            label: "Udaipur",
            value: "udaipur",
        },
        {
            label: "East Sikkim",
            value: "east sikkim",
        },
        {
            label: "North Sikkim",
            value: "north sikkim",
        },
        {
            label: "South Sikkim",
            value: "south sikkim",
        },
        {
            label: "West Sikkim",
            value: "west sikkim",
        },
        {
            label: "Ariyalur",
            value: "ariyalur",
        },
        {
            label: "Chennai",
            value: "chennai",
        },
        {
            label: "Coimbatore",
            value: "coimbatore",
        },
        {
            label: "Cuddalore",
            value: "cuddalore",
        },
        {
            label: "Dharmapuri",
            value: "dharmapuri",
        },
        {
            label: "Dindigul",
            value: "dindigul",
        },
        {
            label: "Erode",
            value: "erode",
        },
        {
            label: "Kanchipuram",
            value: "kanchipuram",
        },
        {
            label: "Kanyakumari",
            value: "kanyakumari",
        },
        {
            label: "Karur",
            value: "karur",
        },
        {
            label: "Krishnagiri",
            value: "krishnagiri",
        },
        {
            label: "Madurai",
            value: "madurai",
        },
        {
            label: "Nagapattinam",
            value: "nagapattinam",
        },
        {
            label: "Namakkal",
            value: "namakkal",
        },
        {
            label: "Nilgiris",
            value: "nilgiris",
        },
        {
            label: "Perambalur",
            value: "perambalur",
        },
        {
            label: "Pudukkottai",
            value: "pudukkottai",
        },
        {
            label: "Ramanathapuram",
            value: "ramanathapuram",
        },
        {
            label: "Salem",
            value: "salem",
        },
        {
            label: "Sivaganga",
            value: "sivaganga",
        },
        {
            label: "Thanjavur",
            value: "thanjavur",
        },
        {
            label: "Theni",
            value: "theni",
        },
        {
            label: "Thoothukudi (Tuticorin)",
            value: "thoothukudi (tuticorin)",
        },
        {
            label: "Tiruchirappalli",
            value: "tiruchirappalli",
        },
        {
            label: "Tirunelveli",
            value: "tirunelveli",
        },
        {
            label: "Tiruppur",
            value: "tiruppur",
        },
        {
            label: "Tiruvallur",
            value: "tiruvallur",
        },
        {
            label: "Tiruvannamalai",
            value: "tiruvannamalai",
        },
        {
            label: "Tiruvarur",
            value: "tiruvarur",
        },
        {
            label: "Vellore",
            value: "vellore",
        },
        {
            label: "Viluppuram",
            value: "viluppuram",
        },
        {
            label: "Virudhunagar",
            value: "virudhunagar",
        },
        {
            label: "Adilabad",
            value: "adilabad",
        },
        {
            label: "Bhadradri Kothagudem",
            value: "bhadradri kothagudem",
        },
        {
            label: "Hyderabad",
            value: "hyderabad",
        },
        {
            label: "Jagtial",
            value: "jagtial",
        },
        {
            label: "Jangaon",
            value: "jangaon",
        },
        {
            label: "Jayashankar Bhoopalpally",
            value: "jayashankar bhoopalpally",
        },
        {
            label: "Jogulamba Gadwal",
            value: "jogulamba gadwal",
        },
        {
            label: "Kamareddy",
            value: "kamareddy",
        },
        {
            label: "Karimnagar",
            value: "karimnagar",
        },
        {
            label: "Khammam",
            value: "khammam",
        },
        {
            label: "Komaram Bheem Asifabad",
            value: "komaram bheem asifabad",
        },
        {
            label: "Mahabubabad",
            value: "mahabubabad",
        },
        {
            label: "Mahabubnagar",
            value: "mahabubnagar",
        },
        {
            label: "Mancherial",
            value: "mancherial",
        },
        {
            label: "Medak",
            value: "medak",
        },
        {
            label: "Medchal",
            value: "medchal",
        },
        {
            label: "Nagarkurnool",
            value: "nagarkurnool",
        },
        {
            label: "Nalgonda",
            value: "nalgonda",
        },
        {
            label: "Nirmal",
            value: "nirmal",
        },
        {
            label: "Nizamabad",
            value: "nizamabad",
        },
        {
            label: "Peddapalli",
            value: "peddapalli",
        },
        {
            label: "Rajanna Sircilla",
            value: "rajanna sircilla",
        },
        {
            label: "Rangareddy",
            value: "rangareddy",
        },
        {
            label: "Sangareddy",
            value: "sangareddy",
        },
        {
            label: "Siddipet",
            value: "siddipet",
        },
        {
            label: "Suryapet",
            value: "suryapet",
        },
        {
            label: "Vikarabad",
            value: "vikarabad",
        },
        {
            label: "Wanaparthy",
            value: "wanaparthy",
        },
        {
            label: "Warangal (Rural)",
            value: "warangal (rural)",
        },
        {
            label: "Warangal (Urban)",
            value: "warangal (urban)",
        },
        {
            label: "Yadadri Bhuvanagiri",
            value: "yadadri bhuvanagiri",
        },
        {
            label: "Dhalai",
            value: "dhalai",
        },
        {
            label: "Gomati",
            value: "gomati",
        },
        {
            label: "Khowai",
            value: "khowai",
        },
        {
            label: "North Tripura",
            value: "north tripura",
        },
        {
            label: "Sepahijala",
            value: "sepahijala",
        },
        {
            label: "South Tripura",
            value: "south tripura",
        },
        {
            label: "Unakoti",
            value: "unakoti",
        },
        {
            label: "West Tripura",
            value: "west tripura",
        },
        {
            label: "Almora",
            value: "almora",
        },
        {
            label: "Bageshwar",
            value: "bageshwar",
        },
        {
            label: "Chamoli",
            value: "chamoli",
        },
        {
            label: "Champawat",
            value: "champawat",
        },
        {
            label: "Dehradun",
            value: "dehradun",
        },
        {
            label: "Haridwar",
            value: "haridwar",
        },
        {
            label: "Nainital",
            value: "nainital",
        },
        {
            label: "Pauri Garhwal",
            value: "pauri garhwal",
        },
        {
            label: "Pithoragarh",
            value: "pithoragarh",
        },
        {
            label: "Rudraprayag",
            value: "rudraprayag",
        },
        {
            label: "Tehri Garhwal",
            value: "tehri garhwal",
        },
        {
            label: "Udham Singh Nagar",
            value: "udham singh nagar",
        },
        {
            label: "Uttarkashi",
            value: "uttarkashi",
        },
        {
            label: "Agra",
            value: "agra",
        },
        {
            label: "Aligarh",
            value: "aligarh",
        },
        {
            label: "Allahabad",
            value: "allahabad",
        },
        {
            label: "Ambedkar Nagar",
            value: "ambedkar nagar",
        },
        {
            label: "Amethi (Chatrapati Sahuji Mahraj Nagar)",
            value: "amethi (chatrapati sahuji mahraj nagar)",
        },
        {
            label: "Amroha (J.P. Nagar)",
            value: "amroha (j.p. nagar)",
        },
        {
            label: "Auraiya",
            value: "auraiya",
        },
        {
            label: "Azamgarh",
            value: "azamgarh",
        },
        {
            label: "Baghpat",
            value: "baghpat",
        },
        {
            label: "Bahraich",
            value: "bahraich",
        },
        {
            label: "Ballia",
            value: "ballia",
        },
        {
            label: "Balrampur",
            value: "balrampur",
        },
        {
            label: "Banda",
            value: "banda",
        },
        {
            label: "Barabanki",
            value: "barabanki",
        },
        {
            label: "Bareilly",
            value: "bareilly",
        },
        {
            label: "Basti",
            value: "basti",
        },
        {
            label: "Bhadohi",
            value: "bhadohi",
        },
        {
            label: "Bijnor",
            value: "bijnor",
        },
        {
            label: "Budaun",
            value: "budaun",
        },
        {
            label: "Bulandshahr",
            value: "bulandshahr",
        },
        {
            label: "Chandauli",
            value: "chandauli",
        },
        {
            label: "Chitrakoot",
            value: "chitrakoot",
        },
        {
            label: "Deoria",
            value: "deoria",
        },
        {
            label: "Etah",
            value: "etah",
        },
        {
            label: "Etawah",
            value: "etawah",
        },
        {
            label: "Faizabad",
            value: "faizabad",
        },
        {
            label: "Farrukhabad",
            value: "farrukhabad",
        },
        {
            label: "Fatehpur",
            value: "fatehpur",
        },
        {
            label: "Firozabad",
            value: "firozabad",
        },
        {
            label: "Gautam Buddha Nagar",
            value: "gautam buddha nagar",
        },
        {
            label: "Ghaziabad",
            value: "ghaziabad",
        },
        {
            label: "Noida",
            value: "noida",
        },
        {
            label: "Guwahati",
            value: "guwahati",
        },
        {
            label: "Ghazipur",
            value: "ghazipur",
        },
        {
            label: "Gonda",
            value: "gonda",
        },
        {
            label: "Gorakhpur",
            value: "gorakhpur",
        },
        {
            label: "Hamirpur",
            value: "hamirpur",
        },
        {
            label: "Hapur (Panchsheel Nagar)",
            value: "hapur (panchsheel nagar)",
        },
        {
            label: "Hardoi",
            value: "hardoi",
        },
        {
            label: "Hathras",
            value: "hathras",
        },
        {
            label: "Jalaun",
            value: "jalaun",
        },
        {
            label: "Jaunpur",
            value: "jaunpur",
        },
        {
            label: "Jhansi",
            value: "jhansi",
        },
        {
            label: "Kannauj",
            value: "kannauj",
        },
        {
            label: "Kanpur Dehat",
            value: "kanpur dehat",
        },
        {
            label: "Kanpur Nagar",
            value: "kanpur nagar",
        },
        {
            label: "Kanshiram Nagar (Kasganj)",
            value: "kanshiram nagar (kasganj)",
        },
        {
            label: "Kaushambi",
            value: "kaushambi",
        },
        {
            label: "Kushinagar (Padrauna)",
            value: "kushinagar (padrauna)",
        },
        {
            label: "Lakhimpur - Kheri",
            value: "lakhimpur - kheri",
        },
        {
            label: "Lalitpur",
            value: "lalitpur",
        },
        {
            label: "Lucknow",
            value: "lucknow",
        },
        {
            label: "Maharajganj",
            value: "maharajganj",
        },
        {
            label: "Mahoba",
            value: "mahoba",
        },
        {
            label: "Mainpuri",
            value: "mainpuri",
        },
        {
            label: "Mathura",
            value: "mathura",
        },
        {
            label: "Mau",
            value: "mau",
        },
        {
            label: "Meerut",
            value: "meerut",
        },
        {
            label: "Mirzapur",
            value: "mirzapur",
        },
        {
            label: "Moradabad",
            value: "moradabad",
        },
        {
            label: "Muzaffarnagar",
            value: "muzaffarnagar",
        },
        {
            label: "Pilibhit",
            value: "pilibhit",
        },
        {
            label: "Pratapgarh",
            value: "pratapgarh",
        },
        {
            label: "RaeBareli",
            value: "raebareli",
        },
        {
            label: "Rampur",
            value: "rampur",
        },
        {
            label: "Saharanpur",
            value: "saharanpur",
        },
        {
            label: "Sambhal (Bhim Nagar)",
            value: "sambhal (bhim nagar)",
        },
        {
            label: "Sant Kabir Nagar",
            value: "sant kabir nagar",
        },
        {
            label: "Shahjahanpur",
            value: "shahjahanpur",
        },
        {
            label: "Shamali (Prabuddh Nagar)",
            value: "shamali (prabuddh nagar)",
        },
        {
            label: "Shravasti",
            value: "shravasti",
        },
        {
            label: "Siddharth Nagar",
            value: "siddharth nagar",
        },
        {
            label: "Sitapur",
            value: "sitapur",
        },
        {
            label: "Sonbhadra",
            value: "sonbhadra",
        },
        {
            label: "Sultanpur",
            value: "sultanpur",
        },
        {
            label: "Unnao",
            value: "unnao",
        },
        {
            label: "Varanasi",
            value: "varanasi",
        },
        {
            label: "Alipurduar",
            value: "alipurduar",
        },
        {
            label: "Bankura",
            value: "bankura",
        },
        {
            label: "Birbhum",
            value: "birbhum",
        },
        {
            label: "Burdwan (Bardhaman)",
            value: "burdwan (bardhaman)",
        },
        {
            label: "Cooch Behar",
            value: "cooch behar",
        },
        {
            label: "Dakshin Dinajpur (South Dinajpur)",
            value: "dakshin dinajpur (south dinajpur)",
        },
        {
            label: "Darjeeling",
            value: "darjeeling",
        },
        {
            label: "Hooghly",
            value: "hooghly",
        },
        {
            label: "Howrah",
            value: "howrah",
        },
        {
            label: "Jalpaiguri",
            value: "jalpaiguri",
        },
        {
            label: "Kalimpong",
            value: "kalimpong",
        },
        {
            label: "Kolkata",
            value: "kolkata",
        },
        {
            label: "Malda",
            value: "malda",
        },
        {
            label: "Murshidabad",
            value: "murshidabad",
        },
        {
            label: "Nadia",
            value: "nadia",
        },
        {
            label: "North 24 Parganas",
            value: "north 24 parganas",
        },
        {
            label: "Paschim Medinipur (West Medinipur)",
            value: "paschim medinipur (west medinipur)",
        },
        {
            label: "Purba Medinipur (East Medinipur)",
            value: "purba medinipur (east medinipur)",
        },
        {
            label: "Purulia",
            value: "purulia",
        },
        {
            label: "South 24 Parganas",
            value: "south 24 parganas",
        },
        {
            label: "Uttar Dinajpur (North Dinajpur)",
            value: "uttar dinajpur (north dinajpur)",
        },
    ],
};